
import Vue from "vue";

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    iconSize: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: "#4B4B4B",
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
});

interface Props {
  iconSize: number;
  fill: string;
  onClick: () => void;
}
